const AmityFeeData = {
    coursefee: "1,70,000",
    hostelfee: "15,000",
};
export default AmityFeeData;
